import type { CaseStudy } from "./types";

const cs: CaseStudy = {
  slug: "dakar-wave",
  founder: "Mor Ndiaye",
  company: "Wave Studio",
  city: "Lomé",
  country: "Togo",
  pillar: "fractional",
  outcomeShort: {
    en: "Closed €1.2M seed with a fractional CFO in 11 weeks",
    fr: "Closing seed à 1,2 M€ avec un CFO fractionné en 11 semaines",
  },
  title: {
    en: "How Wave Studio closed a €1.2M seed round with a fractional CFO",
    fr: "Comment Wave Studio a closé un seed de 1,2 M€ avec un CFO fractionné",
  },
  subtitle: {
    en: "A 2-day-a-week fractional CFO rebuilt the financial model, managed the data room, and led every investor call.",
    fr: "Un CFO fractionné à 2 jours/semaine a refait le modèle financier, géré la data room et mené chaque call investisseur.",
  },
  body: {
    en: {
      context: "Wave Studio is a creator-economy SaaS for francophone African TikTok and Instagram creators. Mor had product-market fit signals (5 000 active creators, €18k MRR) but no finance background.",
      challenge: "He had three soft-circled angels but no model, no data room, and no idea how to run a structured raise. Two prior raise attempts had stalled at the term-sheet stage.",
      approach: "He hired a fractional CFO through Bootpreneurs (former CFO of two African Series-A companies) for 2 days/week over 12 weeks. Week 1–3: financial model + cohort retention rebuild. Week 4–6: data room + 3-year scenario plan. Week 7–11: investor pipeline + term-sheet negotiation.",
      outcome: "Closed €1.2M at a €6M post-money valuation in week 11, led by Partech Africa. The fractional CFO continues 1 day/week as a board observer.",
      quote: "A full-time CFO would have cost €120k/year and I couldn't afford one. The fractional model gave me the same outcome at a fifth of the cost.",
      quoteAuthor: "Mor Ndiaye · Founder & CEO, Wave Studio",
    },
    fr: {
      context: "Wave Studio est un SaaS creator-economy pour les créateurs TikTok et Instagram francophones d'Afrique. Mor avait des signaux de product-market fit (5 000 créateurs actifs, 18 k€ MRR) mais aucun background finance.",
      challenge: "Il avait trois business angels soft-circled mais aucun modèle, pas de data room, et aucune idée de comment piloter une levée structurée. Deux tentatives précédentes avaient calé au stade term-sheet.",
      approach: "Il a embauché un CFO fractionné via Bootpreneurs (ancien CFO de deux Series-A africaines) à 2 jours/semaine sur 12 semaines. S1–3 : modèle financier + rebuild de la rétention par cohorte. S4–6 : data room + plan 3 ans en scénarios. S7–11 : pipeline investisseurs + négociation term-sheet.",
      outcome: "Closing de 1,2 M€ à 6 M€ post-money en semaine 11, lead par Partech Africa. Le CFO fractionné continue à 1 jour/semaine comme observateur board.",
      quote: "Un CFO temps plein aurait coûté 120 k€/an et je ne pouvais pas me le permettre. Le modèle fractionné m'a donné le même résultat à un cinquième du prix.",
      quoteAuthor: "Mor Ndiaye · Fondateur & CEO, Wave Studio",
    },
  },
};
export default cs;
